module.exports = "/images/global@2x.png?530dfeb9c400133fa16fbf95adb20a10";